import { Injectable } from '@angular/core';
import { Campaign } from 'src/app/core/models/Campaign.model';
import { DataService } from 'src/app/core/services/data.service';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { CampaignInfo } from '../../core/models/campaign_info';
import { OldDataService } from 'src/app/core/services/old-data.service';
import { UtilsService } from '../utils/utils.service';
import { ResponseService } from 'src/app/core/models/response-service.model';

@Injectable({
	providedIn: 'root',
})
export class CampaignService {
	constructor(
		private dataService: DataService,
		private http: HttpClient,
		private utils: UtilsService,
		private oldDataService: OldDataService,
	) { }

	saveCampaign(campaign: any, criterias: any = {}, campaign_info: any = {}) {
		const url = `${environment.api}campaign/save_campaign`;
		return this.dataService.postNewCampaign(url, {
			campaign: campaign,
			criterias: criterias,
			campaign_info: campaign_info,
		});
	}

	saveCampaignNew(campaign: any) {
		const url = `${environment.api}campaign/save_campaign`;
		const formData: any = this.utils.jsonToFormData(campaign);
		return this.http.post(url, formData);
	}

	updateCampaignBasicInfo(payload) {
		const url = `${environment.api}campaign/update_campaign_basic_info`;
		const formData: any = this.utils.jsonToFormData(payload);
		return this.http.post(url, formData);
	}



	assignRecordsToCampaign(campaignId: any) {
		const url = `${environment.api}campaigns/assign_records_campaign`;
		return this.http.post(url, {
			campaignId: campaignId,
			criteria: 'x',
		});
	}

	recycleRecordsToCampaign(campaignId: any) {
		const url = `${environment.api}campaigns/${campaignId}/recycle_records`;
		return this.http.get(url);
	}

	// TODO: VALIDAR PORQUE ESTAS DOS FUNCIONES HACEN LO MISMO
	deleteRecordsToCampaign(campaignId: any) {
		const url = `${environment.api}campaigns/delete_records_campaign`;
		return this.dataService.post(url, {
			campaignId: campaignId,
			criteria: 'x',
		});
	}

	resetNeededCampaign(campaignId: any) {
		const url = `${environment.api}campaigns/delete_records_campaign`;
		return this.dataService.post(url, {
			campaignId: campaignId,
			criteria: 'x',
		});
	}

	updateCampaign(campaign: any, campaign_info: CampaignInfo, email_template: any) {
		const url = `${environment.api}campaigns/update_campaign`;
		const formData: any = this.utils.jsonToFormData({ campaign: JSON.stringify(campaign), campaign_info: JSON.stringify(campaign_info), email_template: JSON.stringify(email_template) });
		return this.http.post(url, formData);
	}

	getAllCampaigns() {
		const url = `${environment.api}campaigns/get_all_campaigns`;
		return this.http.get(url);
	}

	getAllCampaignsMedatada() {
		const url = `${environment.api}campaigns/get_all_campaigns_metadata`;
		return this.http.get(url);
	}

// TODO: REVISAR SI SE ESTA USANDO O NO, ESTA COMENDATA EN BACKEND
	updateCampaignById(campaign: Campaign) {
		const url: string = `${environment.api}campaign/update`;
		return this.http.post(url, { campaign: 'asdad' });
	}

	getTotalRecordsCampaignById(campaignId: number): Observable<any> {
		const url: string = `${environment.api}campaign/get_records_count_by_id/${campaignId}`;
		return this.http.get(url);
	}

	getDisposCampaignById(campaignId: number): Observable<any> {
		const url: string = `${environment.api}campaign/get_dispo_count_by_campaign/${campaignId}`;
		return this.http.get(url);
	}

	getDisposCountTypeById(campaignId: number, dispo: string): Observable<any> {
		const url: string = `${environment.api}campaign/get_dispo_counts_by_campaign/${campaignId}/${dispo}`;
		return this.http.get(url);
	}

	// TODO: REVISAR SI SE ESTA USANDO O NO, ESTA COMENDATA EN BACKEND
	getListUsers(campaignId: any) {//REVISAR
		const url =
			`${environment.api}campaign/get_users_by_campaign?campaignId=` +
			campaignId;
		return this.http.get<ResponseService>(url);
	}


	getLeadsStatus(campaign_id) {
		const url = `${environment.api}lead/${campaign_id}/get_leads_status_count`;
		return this.http.get(url);
	}

	getCampaignHourlyInfo(campaign_id: number) {
        const url = `${environment.api}campaigns/${campaign_id}/get_campaign_hours_by_campaign`;
        return this.http.get<ResponseService>(url);
    }

	addWorkedHours(hours, new_time_stamp, campaign_id, date){
		const url = `${environment.api}campaign/add_hours`;
		const formData: any = this.utils.jsonToFormData({ hours, new_time_stamp, campaign_id, date});
		return this.http.post(url, formData);
	}



	addPrice(data){
		const url = `${environment.api}campaign/add_price`;
		const formData: any = this.utils.jsonToFormData(data);
		return this.http.post(url, formData);
	}

	editPrice(data){
		const url = `${environment.api}campaign/edit_price`;
		const formData: any = this.utils.jsonToFormData(data);
		return this.http.post(url, formData);
	}

	getCampaignPrices(campaignId){
		const url = `${environment.api}campaign/${campaignId}/get_prices`;
		return this.http.get(url);
	}

	deletePrice(id){
		const url = `${environment.api}campaign/${id}/delete_price`;
		return this.http.get(url);
	}

	updateLeadsNeeded(payload: any){//uasada
		const url = `${environment.api}campaign/update_leads_needed`;
		const formData: any = this.utils.jsonToFormData(payload);
		return this.http.post(url, formData);
	}

	resetAllNeededCampaigns() {
		const url = `${environment.api}campaigns/reset_all_needed_campaigns`;
		return this.http.get(url);
	}

	resetAllNeededCampaigns2(): Promise<any> {
		const url = `${environment.api}campaigns/reset_all_needed_campaigns`;
		return new Promise((resolve) => {
			return this.http.get(url).subscribe((data) => {
				resolve(data);
			});
		});
	}


	downloadCampaignRecords(payload){
		const url = `${environment.api}campaigns/download_campaign_records`;
		const formData: any = this.utils.jsonToFormData(payload);
		return this.http.post(url, formData);
	}

	deactivateCampaign(campaign_id){
		const url = `${environment.api}campaign/${campaign_id}/deactivate_campaign`;
		return this.http.get(url);
	}

	activateCampaign(campaign_id){//uasada
		const url = `${environment.api}campaign/${campaign_id}/activate_campaign`;
		return this.http.get(url);
	}

	getCampaignsForSelect(isActive: string = 'all'){
		const url = `${environment.api}utilidades/${isActive}/get_campaigns_for_select`;
		return this.http.get<any[]>(url);
	}

	getSelectSearchCampaigns(isActive: string = 'all'): Observable<any[]> {
		const url = `${environment.api}utils/${isActive}/get_select_search_campaigns`;
		return this.http.get<any[]>(url);
	}

	getCampaignCallSheet(campaign_id){
		const url = `${environment.api}campaign/${campaign_id}/get_call_sheet`;
		return this.http.get(url);
	}

	getDisposToCount(campaign_id){
		const url = `${environment.api}campaign/${campaign_id}/get_dispo_count_by_campaign`;
		return this.http.get(url);
	}

	getCampaignDispoLogByDate(payload: any){
		const url = `${environment.api}campaign/get_campaign_dispo_log_by_date`;
		const formData: any = this.utils.jsonToFormData(payload);
		return this.http.post(url, formData);
	}

	// TODO: ENDPOINT NO USADO
	updateCriteria(payload){
		const url = `${environment.api}campaign/update_campaign_criteria`;
		const formData: any = this.utils.jsonToFormData(payload);
		return this.http.post(url, formData);
	}

	assignAllUsersToCampaign(payload){
		const url = `${environment.api}campaign/assign_all_users_to_campaign`;
		const formData: any = this.utils.jsonToFormData(payload);
		return this.http.post(url, formData);
	}

	removeAllUsersFromCampaign(payload){
		const url = `${environment.api}campaign/remove_all_users_from_campaign`;
		const formData: any = this.utils.jsonToFormData(payload);
		return this.http.post(url, formData);
	}

	getCampaignInfoCalendar(campaign_id: any): Observable<any> {
		const url: string =`${environment.api}campaign/${campaign_id}/get_campaign_info_by_id`;
		return this.http.get(url);
	}

	getCampaignById(campaignId: number): Observable<any> {
		const url: string = `${environment.api}campaign/${campaignId}/get_campaign`;
		return this.http.get(url);
	}

	getCampaignAndInfoById(campaignId: number): Observable<any> {
		const url: string = `${environment.api}campaign/${campaignId}/get_campaign_and_info`;
		return this.http.get(url);

	}

	getCampaignInfo(campaignId: any): Observable<any> {//NO
		const url: string =`${environment.api}campaign/${campaignId}/get_campaign_info`;
		return this.http.get(url);
	}

	getCampaignCallers(campaignId){
		const url = `${environment.api}campaign/${campaignId}/get_campaign_callers`;
		return this.http.get(url);
	}

	// ESTOS SON DEL ADMIN CAMPAIGNS

	public countPendingRescheduleLeads(): Observable<any> {
		return this.http.get(
			`${environment.api}campaigns/get_count_pending_reschedules`,
		);
	}

	public getCampaignsCount(isActive: any): Observable<any> {//REVISAR
		return this.http.get(
			`${environment.api}campaigns/get_campaigns_count?isActive=` +
				isActive,
		);
	}

	recycleCampaignRecords(): Promise<any> {
		const url = `${environment.api}campaigns/reset_all_campaigns`;
		return new Promise((resolve) => {
			return this.http.get(url).subscribe((data) => {
				resolve(data);
			});
		});
	}

	getRecordsByID(campaignId: number) {
		const url =
			`${environment.api}campaigns/get_records_by_campaign_id.php?campaignID=` +
			campaignId;
		return this.http.get<ResponseService>(url);
	}

	public getClientUsersSelect() {
		const url = `${environment.api}user/get_customers`;
		return this.http.get<ResponseService>(url);
	}


	deleteProspects(campaign_id: number) {
		const url = `${environment.api}campaign/${campaign_id}/delete_prospects_from_campaign`;
		return this.http.get(url);
	}

	getReserveMovements(campaignId: number) {
		const url = `${environment.api}reserve/${campaignId}/movements`;
		return this.http.get(url);
	}

	addReserveDeposit(payload: any) {
		const url = `${environment.api}reserve/deposit`;
		const formData: any = this.utils.jsonToFormData(payload);
		return this.http.post(url, formData);
	}

	cancelReserveMovement(payload: any) {
		const url = `${environment.api}reserve/cancel`;
		const formData: any = this.utils.jsonToFormData(payload);
		return this.http.post(url, formData);
	}

}
